import { memo, useEffect, useState } from "react";
import ShareIcon from "core/assets/icons/recipe/share-icon.svg";
import CDialog from "../CDialog";
import Icon from 'core/assets/icons';
import { TypeShareSns } from "core/constants";
import { _t } from "core/language";
import { useGoToCreate } from "modules/Community/hooks";

interface ShareComponentProps {
  id?: number;
  title?: string;
  urlImg?: string;
  recipeRequestId?: any;
  isOpen?: boolean;
  onClose?: () => void;
  handleClick?: (e:any) => void;
  link?: string;
  iconShare?: string;
  titlePopup?: string;
  post?: any;
  postType?: 'community' | 'recipe';
}

const CDialogShareSns = ({
  title,
  urlImg,
  isOpen=false,
  handleClick,
  onClose,
  link,
  iconShare,
  titlePopup,
  post,
  postType,
}: ShareComponentProps) => {
  const [stateDialogShareSns, setStateDialogShareSns] = useState(isOpen);
  const [isShowTextCopied, setIsShowTextCopied] = useState(false);

  const goToCreateCommunity = useGoToCreate()

  useEffect(() => {
    setStateDialogShareSns(isOpen);
  }, [isOpen]);

  const linkShareSns = link || ``;
  
  let shareMessage: any = `${title}\n${link}`;
  const shareMessageSns: string = `${title}\n${linkShareSns}`;

  if(postType === 'community') {
    shareMessage = `${link}`;
  }

  const handleShare = () => {
    setStateDialogShareSns(true);
  };

  const handleShareSocial = (type: any) => {
    handleClick?.(type);
    if(type === TypeShareSns.IN_APP) {
      // navigate(RouterName.COMMUNITY_LIST);
      goToCreateCommunity(postType, post);
      return;
    }
    let textShare = shareMessageSns;
    textShare = `${_t('recipe.text_share_sns', {recipe_name: title || ''})}\n${linkShareSns}`;
    if(postType === 'community') {
      textShare = `${linkShareSns}`;
    }
    const dataShareSns = {
      content: textShare,
      url: linkShareSns,
      urlImg: urlImg
    };
    console.log(type,dataShareSns, 'handleShareSocial', shareMessageSns);
    (window as any).webViewRequestShareSns(type, dataShareSns);
    setTimeout(() => {
      setStateDialogShareSns(false);
      onClose?.();
    }, 1000);
  };

  const handleShareDevice = () => {
    // window.open(`${link}`, "_blank");
    (window as any).webViewRequestShare(shareMessage);
    setStateDialogShareSns(false);
    onClose?.();
  };

  const handleCopy = (value:any) => {
    const valueCopy = value
    const input = document.createElement('input');
    input.setAttribute('readonly', 'readonly');
    input.setAttribute('value', valueCopy);
    document.body.appendChild(input);
    input.setSelectionRange(0, 9999); // Select all text in input
    input.select();
    document.execCommand('copy');
    document.body.removeChild(input);
    setIsShowTextCopied(true);
    setTimeout(() => {
      setIsShowTextCopied(false)
    }, 3000);
  }

  const handleClose = () => {
    setStateDialogShareSns(false)
    onClose?.();
  }

  return (
    <div className="flex">
      {iconShare && <img onClick={handleShare} src={iconShare || ShareIcon} alt="" /> }
      <CDialog
        open={stateDialogShareSns}
        closeModal={handleClose}
        classNamechildren={'pb-[20px]'}
        isButton={false}
      >
        <div>
          <h3 className="text-[14px] font-medium text-[#111111]">{titlePopup || _t('recipe.title_share_sns')}</h3>
          <div className="py-[20px]">
            <div className="flex gap-x-2.5 justify-center">
              <button onClick={() => handleShareSocial(TypeShareSns.IN_APP)} className="gap-y-2">
                <img
                  src={Icon.InAppShare}
                  alt={'InAppShare'}
                  className="object-contain shrink-0 aspect-square w-[50px]"
                />
              </button>
              <button onClick={() => handleShareSocial(TypeShareSns.FACEBOOK)} className="gap-y-2">
                <img
                  src={Icon.FbShare}
                  alt={'FbShare'}
                  className="object-contain shrink-0 aspect-square w-[50px]"
                />
              </button>
              {/* <button onClick={() => handleShareSocial(TypeShareSns.INSTAGRAM)} className="gap-y-2">
                <img
                  src={Icon.InstagramShare}
                  alt={'InstagramShare'}
                  className="object-contain shrink-0 aspect-square w-[50px]"
                />
              </button> */}
              <button onClick={() => handleShareSocial(TypeShareSns.KAKAOTALK)} className="gap-y-2">
                <img
                  src={Icon.KakaoShare}
                  alt={'KakaoShare'}
                  className="object-contain shrink-0 aspect-square w-[50px]"
                />
              </button>
              {/* <button onClick={() => goToCreateCommunity(recipe)} className="gap-y-2">
                community
              </button> */}
              <button onClick={() => handleShareDevice()} className="gap-y-2">
                <img
                  src={Icon.MoreShare}
                  alt={'MoreShare'}
                  className="object-contain shrink-0 aspect-square w-[50px]"
                />
              </button>
            </div>
          </div>
          <div className="bg-[#f8f8f8] rounded-[4px]">
            <div className={`flex justify-between pl-[10px] items-center h-[40px] pr-[20px] relative ${isShowTextCopied ? ' pl-[5px] pr-[12px]' : ''}`}>
              <div className={`flex items-center w-[calc(100%-65px)] ${isShowTextCopied ? ' w-[calc(100%-78px)]' : ''}`}>
                <img
                  src={Icon.CopyShare}
                  alt={'CopyShare'}
                  className="object-contain shrink-0 aspect-square w-[18px] h-[18px] mr-[5px]"
                />
                <label htmlFor="" className="text-[12px] whitespace-nowrap overflow-hidden">{linkShareSns}</label>
              </div>
              {/* {isShowTextCopied ? <div className="px-[5px] absolute top-[-35px] h-[30px] text-[10px] rounded-[6px] bg-[#8080802e] right-[12px] flex items-center">{_t("recipe.copy")}</div> : ''} */}
              <label htmlFor="" className={`text-[12px] text-[#999999] font-medium whitespace-nowrap ${isShowTextCopied ? ' !text-[#2FCF78]' : ''}`} onClick={() => handleCopy(linkShareSns)}>{isShowTextCopied ? _t('recipe.copied') : _t('recipe.copy')}</label>
            </div>
          </div>
        </div>
      </CDialog>
    </div>
  );
};

export default memo(CDialogShareSns);
